import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

let jobData = [];
let structuredJobData = [];
let jobDepartments = [];
let jobDivisions = [];
let jobLookup = new Map();

export const fetchJobs = createAsyncThunk("jobsSlice/fetchJobs", async () => {
    try {
        let fmRes = await axiosInstance({
            method: "get",
            url: "/jva",
        });

        jobData = fmRes?.data?.data;

        jobData.forEach((job) => {
            let jobPosition = {
                closingDate: job.closingDate ?? "",
                department: job.department ?? "",
                division: job.division ?? "",
                jobDutiesResponsibilities: job.jobDutiesResponsibilities ?? "",
                jobSkillSet: job.jobSkillSet ?? "",
                jobMinimumQualification: job.jobMinimumQualification ?? "",
                jobAdditionalRequirements: job.jobAdditionalRequirements ?? "",
                jobSpecialRequirements: job.jobSpecialRequirements ?? "",
                jobEmpoymentType: job.jobEmpoymentType ?? "",
                jobWorkEnv: job.jobWorkEnv ?? "",
                jobWorkDays: job.jobWorkDays ?? "",
                jobWorkHours: job.jobWorkHours ?? "",
                jobSensitivity: job.jobSensitivity ?? "",
                link: job.reqID ?? "",
                location: job.location ?? "",
                payRate: job.payRate ?? "",
                positionNumber: job.positionNumber ?? "",
                positionTitle: job.positionTitle ?? "",
                reqID: job.reqID ?? "",
                tags: job.tags ?? "",
                dateOpen: job.dateOpen ?? "",
                rate:job.rate ?? "",
                positionInHouse : job.positionInHouse ?? ""
            };
            // Add the job into the hashmap jobLookup as a key value pair: {key: reqID, value: job}.
            jobLookup.set(jobPosition.reqID, jobPosition);

            // Add job into list of structured job lists.
            structuredJobData.push(jobPosition);

            //add departments and divisions to array that are then filtered onto the dropdown menu
            jobDepartments.push(jobPosition.department);
            jobDivisions.push(jobPosition.division);
        });

        // Sort viewable job list on position title A-Z
        structuredJobData.sort((a, b) => {
            let res = new Date(b.dateOpen) - new Date(a.dateOpen);
                return res;
        }
    
        );

        return {
            jobs: structuredJobData,
            departments: jobDepartments,
            divisions: jobDivisions,
        };
    } catch (error) {
        console.error(error);
        return Promise.reject(error);
    }
});

export { jobLookup };
